/**
 * 특사(대리인) 선택 기업 컨텍스트.
 * axios / download 가 `x-company-idx` 헤더로 전달한다.
 */
export function getManagedCompanyIdx() {
  if (typeof window === "undefined" || !window.sessionStorage) return null;
  const idx = String(
    sessionStorage.getItem("manage_company_idx") || ""
  ).trim();
  return idx || null;
}

export function isAgentSession() {
  if (typeof window === "undefined") return false;
  const auth = Number(
    sessionStorage.getItem("auth") ?? sessionStorage.getItem("rank")
  );
  if (!Number.isFinite(auth)) return false;
  return Boolean(window.$Global?.checkAuth?.("대리인", auth));
}

/** 특사이고 선택 기업이 있을 때만 회사 헤더 객체 반환 */
export function getWorkingCompanyHeaders() {
  if (!isAgentSession()) return {};
  const companyIdx = getManagedCompanyIdx();
  if (!companyIdx) return {};
  return {
    "x-company-idx": companyIdx,
    "x-target-company-idx": companyIdx,
  };
}
